import { DEFAULT_PALETTE } from "../../constants/palettes";
import { ButtonSize } from "../button";
export var defaultProps = {
  size: ButtonSize.Medium,
  palette: DEFAULT_PALETTE,
  onClick: function onClick() {}
};